import {useSelector} from "react-redux";
import {Navigate} from "react-router-dom";

const GuestGuard = ({children}) => {
    const {isLoggedIn} = useSelector((state) => state?.auth);

    return !isLoggedIn ? children : <Navigate to="/home" />;
};

export default GuestGuard;
